export {};

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    portalCloseMenu: () => void;
    portalToggleMenu: () => void;
    portalMenuInitialized?: boolean;
  }
}

const getPortalMenu = () => document.getElementById("portal-menu");

const setPortalMenuOpen = (open: boolean) => {
  const menu = getPortalMenu();
  if (!menu) {
    return;
  }

  menu.classList.toggle("translate-x-full", !open);

  if (open) {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollBarWidth}px`;
  } else {
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }
};

window.portalCloseMenu = () => setPortalMenuOpen(false);
window.portalToggleMenu = () => {
  const menu = getPortalMenu();
  if (!menu) {
    return;
  }

  setPortalMenuOpen(menu.classList.contains("translate-x-full"));
};

const setDropdownOpen = (dropdown: HTMLElement, open: boolean) => {
  const trigger = dropdown.querySelector<HTMLButtonElement>("[data-portal-dropdown-trigger]");
  const menu = dropdown.querySelector<HTMLElement>("[data-portal-dropdown-menu]");
  const closedIcon = dropdown.querySelector<HTMLElement>('[data-portal-dropdown-icon="closed"]');
  const openIcon = dropdown.querySelector<HTMLElement>('[data-portal-dropdown-icon="open"]');

  trigger?.setAttribute("aria-expanded", String(open));
  menu?.classList.toggle("hidden", !open);
  menu?.classList.toggle("flex", open);
  closedIcon?.classList.toggle("hidden", open);
  openIcon?.classList.toggle("hidden", !open);
};

const closePortalDropdowns = (except?: HTMLElement) => {
  document.querySelectorAll<HTMLElement>("[data-portal-dropdown]").forEach((dropdown) => {
    if (dropdown !== except) {
      setDropdownOpen(dropdown, false);
    }
  });
};

if (!window.portalMenuInitialized) {
  window.portalMenuInitialized = true;

  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const trigger = target.closest<HTMLElement>("[data-portal-dropdown-trigger]");
    if (trigger) {
      const dropdown = trigger.closest<HTMLElement>("[data-portal-dropdown]");
      if (!dropdown) {
        return;
      }

      const nextOpen = trigger.getAttribute("aria-expanded") !== "true";
      closePortalDropdowns(dropdown);
      setDropdownOpen(dropdown, nextOpen);
      return;
    }

    if (target.closest("[data-portal-dropdown-menu] a, [data-portal-dropdown-menu] button")) {
      closePortalDropdowns();
      window.portalCloseMenu();
      return;
    }

    if (!target.closest("[data-portal-dropdown]")) {
      closePortalDropdowns();
    }
  });

  document.addEventListener("keyup", (event) => {
    if (event.key === "Escape") {
      closePortalDropdowns();
      window.portalCloseMenu();
    }
  });
}
